import { useUserContext } from '@contexts/user'

export const useUserCreatedBeforeDate = (date: string): boolean => {
  const { createdAt } = useUserContext()

  return createdAt ? new Date(createdAt.formatted) < new Date(date) : false
}
